import Index from './index.vue'
import Create from './components/Create.vue'
import List from './components/List.vue'
import Edit from './components/Edit.vue'

export default [{
  path: 'departments',
  name: 'departments',
  component: Index,
  title: 'departments',
  redirect: {
    name: 'classes-list'
  },
  children: [{
      path: 'list',
      name: 'classes-list',
      component: List,
    },
    {
      path: 'create',
      name: 'classes-create',
      component: Create,
    },
    {
      path: ':id/edit',
      name: 'classes-edit',
      component: Edit,
    },
  ],
}, ]